export default "__VITE_ASSET__e8c8cdc8__"